import {Component} from '@angular/core';
import {AbstractButton} from '../abstract-button';

@Component({
    selector: 'vui-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent extends AbstractButton {
    constructor() {
        super();
    }
}
